import React, {useState, useEffect} from 'react'
import InputField from '../../module/input'
import File from '../../module/file'
import Category from './Category'
import Location from '../../module/location'
import Button from '../../module/button'
import {Style} from './style/Style'

import {useRecoilState, useRecoilValue, useSetRecoilState} from 'recoil'
import {CategoryAction} from '../../../store/action'
import {loaderAtom} from '../../../store/recoil/loader'
import {alertAtom} from '../../../store/recoil/alert'
import {CategoryInterface} from '../../../layout/default/types'
import category from './Category'

const Index = (props: any) => {
  const setAlert = useSetRecoilState(alertAtom)
  const {regisCategory, getCategoryList} = CategoryAction()
  const [categoryList, setCategoryList] = useState<CategoryInterface[]>([])
  const [state, setState] = useState<any>({
    name: null,
    code: null,
    order: null,
    image: null
  })

  useEffect(() => {
    getCategoryList({page: 0, size: 100})
      .then((res) => {
        setCategoryList(res.data)
      })
  }, [])

  const handleChange = (e: any) => {
    setState({
      ...state,
      [e.target.name]: e.target.value
    })
  }

  const reset = () => {
    setState({
      ...state,
      name: null,
      code: null,
      order: null,
      image: null
    })
  }

  const handleSubmit = () => {
    const {name} = state
    if (!name) {
      setAlert({
        title: '확인',
        type: 'alert',
        message: `제목을 입력하세요`,
        isShow: true
      })
      return
    }

    state.name &&
    regisCategory(state).then((data: any) => {
      setCategoryList((prevCategoryList: any) => [data, ...prevCategoryList])
      reset()
    })
  }

  useEffect(() => {
    return () => {
      // 나갈때..
    }
  })

  const dummy = [
    {
      id: 0,
      parent: 0,
      label: '카테고리',
    },
    {
      id: 1,
      parent: 0,
      label: '상품권',
    }
  ]

  return (
    <Style.Container>
      <Location location={{name: '카테고리 관리'}}/>
      <Style.Content>
        <Style.Section>
          <InputField
            useAnimation={true}
            type="text"
            id="name"
            name="name"
            title="카테고리 이름"
            placeholder="카테고리 이름"
            value={state.name ? state.name : ''}
            onChange={(e) => handleChange(e)}
          />

          <InputField
            useAnimation={true}
            type="text"
            id="code"
            name="code"
            title="카테고리 코드"
            placeholder="카테고리 코드"
            value={state.code ? state.code : ''}
            onChange={(e) => handleChange(e)}
          />

          <InputField
            useAnimation={true}
            type="number"
            id="order"
            name="order"
            title="노출 순서"
            placeholder="노출 순서"
            value={state.order ? state.order : ''}
            onChange={(e) => handleChange(e)}
          />

          <File
            id={'category-image'}
            name={'category-image'}
            isTransform={false}
            placeholder={state.image?.name || '카테고리 이미지 업로드'}
            accept={'.jpg,.jpeg,.png'}
            onChange={(file: any) => setState({
              ...state,
              image: {
                file: file.file,
                thumb: file.thumb,
                name: file.file.name
              }
            })}
          />

          <Style.Action>
            <Button
              margin={'1rem 0 0 0'}
              padding={'1rem 4.4rem'}
              radius={'.5rem'}
              bgcolor={'#3f3b3f'}
              color={'#ffffff'}
              themecolor={'dark-gray'}
              disabled={state.name ? false : true}
              onClick={reset}
            >
              리셋
            </Button>

            <Button
              margin={'1rem 0 0 0'}
              padding={'1rem 4.4rem'}
              radius={'.5rem'}
              bgcolor={'#3f3b3f'}
              color={'#ffffff'}
              themecolor={'dark-gray'}
              disabled={state.name ? false : true}
              onClick={handleSubmit}
            >
              추가
            </Button>
          </Style.Action>
        </Style.Section>

        <Style.Category>
          {
            categoryList ?
              categoryList.map((item: any) => <Category
                key={item.id}
                item={item}
                level={0}
                deleteItem={(id: any) => {
                  const filteredData = categoryList.filter(item => item.id !== id)
                  setCategoryList(filteredData)
                }}
                updateItem={(data: any) => {
                  const filteredData = categoryList.filter(item => {
                    if(item.id === data.id) {
                      item.name = data.name
                      item.code = data.code
                      item.order = data.order
                      item.image = data.image?.thumb || data.image?.path || data.image || item.image
                    }
                    return item
                  })
                  setCategoryList(filteredData)
                }}
              />)
              : <Style.Nodata>등록된 카테고리가 없습니다.</Style.Nodata>
          }
        </Style.Category>
      </Style.Content>
    </Style.Container>
  )
}

export default Index
